import "@/styles/globals.css";
import "@/styles/app.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-loading-skeleton/dist/skeleton.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { AuthProvider } from "./context/AuthContext";
import AppNavigation from "./navigation/AppNavigation";
import Modal from "react-modal";

Modal.setAppElement("#root");

const rootDiv = document.getElementById("root")!;
createRoot(rootDiv).render(
  <Provider store={store}>
    <AuthProvider>
      <RouterProvider router={AppNavigation} />
    </AuthProvider>
  </Provider>,
);
